<script setup lang="ts">
// 我能帮你做's icons, drawn for the AI 助手 rather than taken from the icon
// set: one stroke weight, in the text colour. onboard — a browser window,
// an arrow coming in; diagnose — a magnifier over a pulse; billing — a
// receipt with the yuan sign. (A spark at a corner was tried and dropped:
// it crowded the glyphs.)
withDefaults(defineProps<{ name: 'onboard' | 'diagnose' | 'billing'; size?: number }>(), { size: 24 })
</script>

<template>
  <svg class="action-icon" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true">
    <g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <template v-if="name === 'onboard'">
        <rect x="2.8" y="4" width="15.6" height="13" rx="2.4" />
        <path d="M2.8 8.1h15.6" />
        <path d="M7.4 12.7h5.6M10.8 10.6l2.2 2.1-2.2 2.1" />
      </template>
      <template v-else-if="name === 'diagnose'">
        <circle cx="10.2" cy="10.2" r="6.6" />
        <path d="M15.1 15.1l3.6 3.6" />
        <path d="M6.3 10.5h1.7l1.2-2.4 1.9 4.7 1.2-2.3h1.7" />
      </template>
      <template v-else>
        <path d="M6 3.5h10.4a1.2 1.2 0 0 1 1.2 1.2V20.3l-2.13-1.5-2.14 1.5-2.13-1.5-2.13 1.5-2.14-1.5-2.13 1.5V4.7A1.2 1.2 0 0 1 6 3.5z" />
        <path d="M8.7 7.4l2.5 3.1 2.5-3.1M11.2 10.5v4.7M9 11.8h4.4M9 13.8h4.4" />
      </template>
    </g>
    <template v-if="name === 'onboard'">
      <circle cx="5" cy="6.05" r=".55" fill="currentColor" />
      <circle cx="6.9" cy="6.05" r=".55" fill="currentColor" />
    </template>
  </svg>
</template>

<style scoped>
.action-icon {
  display: block;
  flex: none;
}
</style>
